import React from "react";
import { FaAngleLeft, FaShoppingCart } from "react-icons/fa";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Config } from "../../Config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HeaderCartItem from "../HeaderCartItem/HeaderCartItem";
import { removeFromCart } from "../../Redux/Actions";
import ShopLight from "../../assets/images/ShopLight.svg";
import "./HeaderCartBox.scss";

const HeaderCartBox = (props) => {
  const user = useSelector((state) => state.user);
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  const deleteCartHandler = (product) => {
    cartRemoveHandler(product, product.orderDetailId);
    // dispatch(removeFromCart(product));
  };

  const cartRemoveHandler = (product, orderDetailId) => {
    axios
      .get(`/orders/DeleteOrderDetail/${orderDetailId}`, {
        headers: {
          Authorization: "Bearer " + user[0]?.token,
        },
      })
      .then((result) => {
        if (result.data.status === 200) {
          toast.success(<div>{result.data.messages}</div>);
          dispatch(removeFromCart(product));
        } else {
          toast.error(<div>{result.data.messages}</div>);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getTotalPrice = () => {
    let totalPrice = cart.map((item) => item.unitPrice * item.count);
    return totalPrice.reduce((acc, curr) => acc + curr, 0);
  };

  const badgeHandler = () => {
    let badge = cart.map((item) => item.count);
    return badge.reduce((acc, curr) => acc + curr, 0);
  };

  const gotoCart = () => {
    props.history.replace("/cart");
  };

  return (
    <div className="miniCartShow">
      <span onClick={gotoCart} className="miniCartLink">
        <img src={ShopLight} alt="shopIcon" className="shopIcon" />
        {cart.length > 0 && <span className="badge"> {badgeHandler()} </span>}
      </span>
      {cart.length > 0 && props.location?.pathname !== "/cart" && (
        <div className="cartInfo">
          <div className="cartInfoHeader">
            <p className="cartInfoProductCount"> {cart.length} کالا </p>
            <span onClick={gotoCart} className="cartInfoBtnGoToCart">
              مشاهده سبد خرید <FaAngleLeft />
            </span>
          </div>
          <form action="">
            <div className="cartInfoBody">
              <HeaderCartItem cartData={cart} deleteCartHandler={deleteCartHandler} />
            </div>
            <div className="cartInfoFooter">
              <div className="totalAmountBox">
                <p className="caption"> مبلغ قابل پرداخت </p>
                <p className="totalAmount"> {Config.separate(getTotalPrice())} ریال </p>
              </div>
              <button type="button" className="btnCartSubmit" onClick={props.cartModalHandler}>
                ثبت سفارش
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default React.memo(withRouter(HeaderCartBox));
